import React from "react";
import Product from "component/Product/Product";
import Placeholder from "../../asset/image/Product_Listing_Placeholder.png";

const Productlist = ({ products }) => {
  console.log("products", products);
  return (
    <>
      {products ? (
        products.length ? (
          products.map((product, i) => (
            <div key={i} className="col-6 col-sm-4">
              <Product
                productname={product.name}
                imageUrl={product.image ? product.image : product.image_url}
                available_color={product.available_color}
                urlKey={product.url_key}
                productId={product.id}
                code={product.sku}
                isNew={product.is_new}
                productdiscription={product.description}
                productprice={product.price}
                productimages={product.image}
                logoflagcomponent={
                  product.germfree_non_germ_free === "GF" ? true : false
                }
                logoInternationalcompo={
                  product.international_non_internationa === "JI" ? true : false
                }
                imageALT={product.image_alt}
              />
            </div>
          ))
        ) : (
          <center className="message-box">
            <b>No Product Found </b>
          </center>
        )
      ) : (
        [...Array(12).keys()].map((e) => (
          <div key={e} className="col-6 col-sm-4">
            <div className="product-default inner-quickview inner-icon">
              <figure style={{ minHeight: 269 }} className="imgproduct">
                <img
                  src={Placeholder}
                  alt=""
                  width={240}
                  height={300}
                  loading="lazy"
                />
              </figure>
              <h3 className="product-title">
                <p className="card-text placeholder-glow">
                  <span className="placeholder" style={{ width: "60%" }}></span>
                </p>
              </h3>
              <div className="ratings-container" style={{ width: "100%" }}>
                <p className="card-text placeholder-glow">
                  <span className="placeholder" style={{ width: "75%" }}></span>
                </p>
              </div>
              <div>
                <p className="card-text placeholder-glow">
                  <span className="placeholder" style={{ width: "40%" }}></span>
                </p>
              </div>
            </div>
          </div>
        ))
      )}
    </>
  );
};

export default Productlist;
